// 校验当前是否开启 录音权限
const checkMicrophonePermission = async () => {
  try {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      return false
    }
    // 仅查询权限状态，不实际请求麦克风，避免与 SDK 内部请求冲突
    const permissionStatus = await navigator.permissions.query({ name: 'microphone' })
    if (permissionStatus.state === 'denied') {
      return false
    }
    return true
  } catch (err) {
    // permissions.query 可能不被所有浏览器支持，降级处理：放行由 SDK 自行处理
    console.warn('🚀 ~ checkMicrophonePermission ~ 权限查询不支持，由 SDK 自行处理:', err)
    return true
  }
}

export { checkMicrophonePermission }
